'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const timespan=require('pulsar-utils/dist-es6/time/timespan');
const LiveGroupBasedDataService=require('../../../dist-es6/client/services/liveGroupBasedDataService');
const SocketResponse=require('../../../dist-es6/client/dtos/socketResponse');

const SixHoursInMilliseconds=timespan.fromHours(6).totalMilliseconds();
const TwentyHourTimespan=timespan.fromHours(20);let

ForecastDataService=function(_LiveGroupBasedDataSe){_inherits(ForecastDataService,_LiveGroupBasedDataSe);_createClass(ForecastDataService,null,[{key:'$inject',get:function()
{
return[
'$timeout',
'dateService',
'statisticalDisplayDataService',
'groupTreeService',
'personalIncidentsService'];

}}]);

function ForecastDataService($timeout,dateService,statisticalDisplayDataService,groupTreeService,personalIncidentsService){_classCallCheck(this,ForecastDataService);var _this=_possibleConstructorReturn(this,
_LiveGroupBasedDataSe.call(this,$timeout,dateService,statisticalDisplayDataService,groupTreeService));

_this._personalIncidentsService=personalIncidentsService;return _this;
}ForecastDataService.prototype.

_fetchLatestData=function(){var ref=_asyncToGenerator(function*(){var _this2=this;for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key]}
const[options={}]=args;

const currentTimeForForecast=this._dateService.now();

const[
results,
{incidentTypes:incidentTypes,incidentTypesByCode:incidentTypesByCode}={}]=
yield Promise.all([
this._statisticalDisplayDataService.fetchForecastData(_.defaults({currentTimeForForecast:currentTimeForForecast},options)),
this._personalIncidentsService.getIncidentTypes()]);


return new Promise(function(resolve){
_this2._$timeout(function(){
_this2.currentTimeForForecast=SocketResponse.safeDeserializeDate(results.currentTimeForForecast);
_this2.forecastRange=TimeInterval.from(_this2.currentTimeForForecast.getTime()-SixHoursInMilliseconds).spanning(TwentyHourTimespan);
_this2.incidentTypesByCode=incidentTypesByCode;

resolve(results);
});
});
});function _fetchLatestData(){for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2]}return ref.apply(this,arguments)}return _fetchLatestData}();return ForecastDataService}(LiveGroupBasedDataService);


module.exports=ForecastDataService;
//# sourceMappingURL=forecastDataService.js.map
